import { CallingState, CancelCallButton, OwnCapability, ReactionsButton, Restricted, ScreenShareButton, SpeakerLayout, SpeakingWhileMutedNotification, ToggleAudioPublishingButton, ToggleVideoPublishingButton, useBackgroundFilters, useCall, useCallStateHooks } from "@stream-io/video-react-sdk";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LayoutWithTopBar } from "../../components/LayoutWithTopBar";
import Loader from "./components/Loader";
import { useStream } from "../../hooks/useStream";
import ParticipantViewUI from "./call/ParticipantViewUI";

interface CallPageProps {
    
}

const CallPage: React.FC<CallPageProps> = () => {
    const navigate = useNavigate();
    const call = useCall();
    const { useCallCallingState } = useCallStateHooks();
    const callingState = useCallCallingState();
    const { leaveCall, currentCallData } = useStream();
    const { disableBackgroundFilter } = useBackgroundFilters();
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        disableBackgroundFilter();

        const timer = setTimeout(() => {
            setRefresh(r => !r);
        }, 1000);
    
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if(currentCallData === null) {
            navigate(-1);
        }
    }, [currentCallData]);

    return <LayoutWithTopBar
        onClickPrevArrow={() => navigate(-1)}
        hideLineActiveCall={true}
    >
        {
            call && callingState === CallingState.JOINED ? (
                <div className="text-white max-w-full max-h-full flex flex-col">
                    <div className="flex-1 relative flex overflow-y-auto">
                        <SpeakerLayout ParticipantViewUISpotlight={ParticipantViewUI} />
                    </div>
                    <div className="flex-none">
                        <div className="str-video__call-controls">
                            <Restricted requiredGrants={[OwnCapability.SEND_AUDIO]}>
                                <SpeakingWhileMutedNotification>
                                    <ToggleAudioPublishingButton />
                                </SpeakingWhileMutedNotification>
                            </Restricted>
                            <Restricted requiredGrants={[OwnCapability.SEND_VIDEO]}>
                                <ToggleVideoPublishingButton />
                            </Restricted>
                            <CancelCallButton onLeave={() => {
                                leaveCall();
                            }} />
                        </div>
                    </div>
                </div>
            ) : (
                <Loader />
            )
        }
            
    </LayoutWithTopBar>
}

export default CallPage;